import React from 'react';
/** @jsx jsx */
import { jsx } from 'theme-ui';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import { Button, ButtonText } from '../button/button';
import { rgba } from 'polished';

const folder = process.env.BRANDFOLDER_FOLDER_SLUG;

export const BrandfolderAssetsBySectionStyles = {
  backgroundColor: 'PrimaryBrightBlue',
  margin: '10px 20px 10px 0',
  boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)',
  justifyContent: 'center',
  alignSelf: [null, 'stretch'],
  transition: 'box-shadow .25s ease-out, background-color .25s ease-out',
  '&:hover': {
    backgroundColor: 'PrimaryBrightBlueHover',
    boxShadow: '0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 4px 8px 0 rgba(0, 0, 0, 0.12)',
  },
};

const BrandfolderAssetsBySection = ({ assets, props }) => (
  <div
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
    }}
  >
    {assets && assets.map((asset) => (
      <div
        key={asset.id}
        sx={{
          ...BrandfolderAssetsBySectionStyles,

        }}
        {...props}
      >
        {asset.attachments.map((attachment) => (
          <React.Fragment key={attachment.id}>
            <div
              sx={{
                width: '300px',
                height: '300px',
                margin: '0 auto',
                position: 'relative',
                overflow: 'hidden',
              }}
            >
              <a
                href={`https://cdn.bfldr.com/WZTZRKCG/at/${attachment.id}/${attachment.attributes.filename}?dl=1`}
              >
                <img
                  sx={{
                    minWidth: '300px',
                    minHeight: '300px',
                    height: 'auto',
                    width: 'auto',
                    margin: '0 auto',
                    display: 'block',
                    position: 'relative',
                  }}
                  src={`https://cdn.brandfolder.io/WZTZRKCG/at/${attachment.id}/${attachment.attributes.filename}?height=300px`}
                  alt={asset.name}
                />
                <img
                  sx={{
                    display: 'block',
                    position: 'absolute',
                    width: '58px',
                    height: '58px',
                    bottom: '5px',
                    right: '5px',
                    '&:hover': {
                      bg: 'PrimaryDarkBlue',
                    },
                  }}
                  src="/images/icon_download.svg"
                  alt="download"
                />
              </a>
            </div>
          </React.Fragment>
        ))}
      </div>
    ))}
  </div>
);

BrandfolderAssetsBySection.propTypes = {
  assets: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    attachments: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
    })).isRequired,
  })),
};

BrandfolderAssetsBySection.defaultProps = {
  assets: null,
};

const BrandfolderAssetsBySectionWithQuery = ({ sectionName, ...rest }) => {
  const { sections, assets } = useStaticQuery(graphql`
    query {
      sections: allBrandfolderSection {
        nodes {
          name
          id
          position
        }
      }
      assets: allBrandfolderAsset {
        nodes {
          name
          attachments {
            id
            attributes {
              filename
              url
              thumbnail_url
            }
          }
          sectionId
          id
        }
      }
    }
  `);

  const section = sections ? sections.nodes.find(({ name }) => name === sectionName) : null;
  const sectionAssets = section ? assets.nodes
    .filter(({ sectionId }) => sectionId === section.id) : null;

  return (
    <BrandfolderAssetsBySection
      assets={sectionAssets}
      {...rest}
    />
  );
};

BrandfolderAssetsBySectionWithQuery.propTypes = {
  sectionName: PropTypes.string.isRequired,
};

export default BrandfolderAssetsBySectionWithQuery;
